import { render, staticRenderFns } from "./SiteAlert.vue?vue&type=template&id=342fe4a0"
import script from "./SiteAlert.vue?vue&type=script&lang=js"
export * from "./SiteAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconInfoCircle: require('/opt/atlassian/pipelines/agent/build/components/icon/IconInfoCircle.vue').default,IconArrowRight: require('/opt/atlassian/pipelines/agent/build/components/icon/IconArrowRight.vue').default,IconTimesThin: require('/opt/atlassian/pipelines/agent/build/components/icon/IconTimesThin.vue').default})
